import moment from 'moment'

export const defaultContext = {
  clearFormData() {
    this.rentInfo_model.carId = ''
    this.rentInfo_model.modelId = ''
    this.plateNoList = []
    this.rentInfo_model.startStopDate = []
    this.rentInfo_model.presentDays = ''
    this.rentInfo_model.payPlanFee = null
    this.$emit('manualChangeStartStopDate')
    this.$nextTick(() => {
      this.$refs.rentInfoBox.clearValidate()
    })
  },
  onMounted() {
    // 商城单获取车型和租赁方案
    if (!this.$route.query.orderId || Number(this.$route.query.source) === 2) {
      // 获取租赁方案
      this.getRentPlanList()
      // 获取租赁方案详情
      if (this.planId) {
        this.getPlanDetail({ planId: this.planId })
      }
    }
  },
  onPlanChange(planId) {
    if (planId) {
      this.getPlanDetail({ planId })
    }
    this.clearFormData()
  },
  generateGetPlanParams() {
    return {
      orderType: 1, // 1 个人  2 企业
      state: 1,
      pageNum: 1,
      pageSize: 99999,
      rentCategory: this.rentInfo_model.rentCategory ?? 1, // 默认租车
    }
  },
  // 这是一个Array.prototype.map的reducer工厂，返回的reduer供某一个租赁方案里的费项列表使用
  // this.getPlanDetail()里获取租赁方案详情时会使用
  // this.mounted()里，获取完“可用计租费项”后，也会调用
  onSetFee(feeList) {
    return (arr, fee) => {
      const findFee = feeList.find((i) => i.code === fee.fundType)
      if (findFee) {
        const item = this.context.getFeeItem(fee, findFee)
        arr.push(item)
      }
      return arr
    }
  },
  getFeeItem(data, extData) {
    return {
      ...data,
      isConfirm: true,
      toast: extData.toast, // 提示语
      required: extData.required, // 是否必填费项
      fundType: data.type || data.fundType, // 费项code（押金，租金......）
      name: data.name || data.typeName || data.fundTypeName, // 费项名称
      payMode: data.payMode || data.payMethod, // 收款方式
      isSelectScheme: true, // 是否是选的租赁方案
      amount: data.planAmount, // 金额
      spId: data.spId, // 完单平台
      dynamicType: data.dynamicType, // 动态条件
      dynamicList: data.dynamicList, // 动态租金配置
      payPlanType: data.payPlanType, // 租金类型
    }
  },
  onAddRequiredFee(requestedFees) {
    return requestedFees
  },
  onTranDepositChange() {
    // do nothing
  },
  onPick(time) {
    this.getPlanDetail({
      planId: this.planId,
      startDate: moment(time.minDate).format('YYYY-MM-DD HH:mm:ss'),
    })
  },
}
